import { render, staticRenderFns } from "./MessengerSettings.vue?vue&type=template&id=3045af04&"
import script from "./MessengerSettings.vue?vue&type=script&lang=js&"
export * from "./MessengerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports